/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */
/* eslint-disable no-unused-vars */
// eslint-disable-next-line import/prefer-default-export
export class BaseBookmarkAdapter {
    /**
     * Get bookmarks.
     * @param {string} documentId The bookmark document id.
     *
     * @returns void
     */
    getAll(documentId) {
        throw new Error(`Method not implemented`);
    }

    /**
     * Update an bookmark with new values.
     *
     * @param {object} bookmarks The bookmarks object.
     * @param {string} documentId The bookmark document id.
     *
     * @returns void
     */
    setAll(bookmarks, documentId) {
        throw new Error(`Method not implemented`);
    }
}
